import React from "react";
import Banner6 from "../partials/Banner/Banner6";
import Section1 from "../includes/StolenPackageTrend/Section1";
import { Helmet } from "react-helmet";

const StolenPackageTrend = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://brainbox.company/blogs/stolen-packages-trend-in-usa",
    },
    headline: "What's the trend for stolen packages in the USA?",
    image: "https://brainbox.company/images/blogs/blog-4.png",
    author: {
      "@type": "Organization",
      name: "Brain Box",
      url: "https://brainbox.company",
    },
    publisher: {
      "@type": "Organization",
      name: "Brain Box",
      logo: {
        "@type": "ImageObject",
        url: "https://brainbox.company/images/logo-b.png",
      },
    },
    datePublished: "2023-03-07",
    dateModified: "2023-03-08",
  };

  const imgPath = "url(" + devUrl + "images/our-team/ourteam-banner.png)";

  const bgColor = "$blue-color";
  const minHeight = "400px";

  return (
    <>
      <Helmet>
        <title>Recent Trends in package theft in the USA</title>
        <meta
          name="description"
          content="The number of packages stolen by porch pirates in recent years is difficult to determine, but estimates suggest it is a significant and growing problem."
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
        <link rel="canonical" href="https://brainbox.company/stolen-packages-trend-in-usa" />
      </Helmet>
      <main>
        <article className="our-team">
          <Banner6
            imgPath={imgPath}
            bgColor={bgColor}
            minHeight={minHeight}
            text1={"US trend for stolen packages"}
          />
          <div className="bg-design">
            <Section1 url={devUrl} />
          </div>
        </article>
      </main>
    </>
  );
};

export default React.memo(StolenPackageTrend);
